import { AxiosError } from 'axios';
import { getRequestUrl } from './getRequestUrl';

const MAX_STATUS_WITH_BODY = 500;

export class ApiRequestError extends Error {
  readonly status: number;
  readonly code?: string;
  readonly url?: string;
  readonly data?: unknown;

  constructor(error: AxiosError) {
    super(error.message);

    const status = error.response?.status ?? 0;

    this.name = 'ApiRequestError';
    this.status = status;
    this.code = error.code;
    this.url = getRequestUrl(error);

    if (status < MAX_STATUS_WITH_BODY) {
      this.data = error.response?.data;
    }
  }
}
